import React, { useState } from 'react'
import {
    CommentListWrap
} from './commentListElements'
import CommentItem from "../../../components/commentItem";
import { Button } from "@material-ui/core";
import { FlexLayout } from '../../home/homeElements';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
    viewMore: {
        fontSize: '12px',
    }
}))

const CommentList = ({ comments, newsId }) => {
    const classes = useStyles()
    const {socket} = useSelector(state => state.user)
    const [_page, set_Page] = useState(1)

    const handleViewMore = () => set_Page(_page + 1)

    const rootComment = comments.filter(cmt => !cmt.parentId)
    
    return (
        <>
            <CommentListWrap>
                {rootComment.slice(0, _page * 10).map((comment, index) => (
                    <React.Fragment key={index}>
                        {!comment.parentId &&
                        <>
                            <CommentItem newsId={newsId} comment={comment} />
                            {
                                comments.map(reply => (
                                    reply.parentId === comment._id &&
                                    <CommentItem type='reply' newsId={newsId} parentId={comment._id} socket={socket} comment={reply} key={reply._id} />                                                    ))
                            }
                        </>
                        }
                    </React.Fragment>
                ))}
                
            </CommentListWrap>
            {rootComment.length > _page * 10 && <FlexLayout style={{margin: '16px 0', justifyContent: 'center'}}><Button onClick={handleViewMore} className={classes.viewMore} color="primary">Xem thêm bình luận</Button></FlexLayout>}
        </>
    )
}

export default CommentList
